import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <nav className="fixed top-0 w-full z-50 bg-black/95 backdrop-blur-sm shadow-lg">
      <div className="section-padding py-3 sm:py-4">
        <div className="hidden lg:flex items-center justify-center gap-12 xl:gap-16">
          <div className="flex space-x-4 xl:space-x-6">
            {navItems.slice(0, 2).map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-white hover:text-green-500 transition-colors duration-300 ${
                  location.pathname === item.path ? 'border-b-2 border-green-500' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <Link to="/" className="flex items-center justify-center">
            <img 
              src="/Image/GRAPHIIC ZONE LOGO 2.png" 
              alt="GRAPHIC ZONE STUDIO" 
              className="h-12 md:h-14 w-auto"
            />
          </Link>
          
          <div className="flex space-x-4 xl:space-x-6">
            {navItems.slice(2).map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-white hover:text-green-500 transition-colors duration-300 ${
                  location.pathname === item.path ? 'border-b-2 border-green-500' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="flex lg:hidden justify-between items-center">
          <Link to="/" className="flex items-center">
            <img 
              src="/Image/GRAPHIIC ZONE LOGO 2.png" 
              alt="GRAPHIC ZONE STUDIO" 
              className="h-10 sm:h-12 md:h-14 w-auto"
            />
          </Link>
          
          <div className="hidden lg:flex space-x-6 xl:space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className={`text-white hover:text-green-500 transition-colors duration-300 ${
                  location.pathname === item.path ? 'border-b-2 border-green-500' : ''
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <button
            className="text-white hover:text-green-500"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
                d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="mt-4 pb-4 bg-black/95 rounded-lg">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                className="block text-white py-2 hover:text-green-500"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Link to="/booking" className="block mt-4 btn-primary text-center">
              Book Session
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
